export const CONTACT_JOIN_CMS_BUNDLE_FORMAT = "alramlaa-contact-join-cms";

const CONTACT_DEFAULT = {
  mainText: "",
  arMainText: "",
  sectionTitle: "",
  arSectionTitle: "",
  subText: "",
  arSubText: "",
  description: "",
  arDescription: "",
};

const JOIN_DEFAULT = {
  mainText: "",
  arMainText: "",
  sectionTitle: "",
  arSectionTitle: "",
  description: "",
  arDescription: "",
};

function str(v) {
  if (v == null) return "";
  return typeof v === "string" ? v : String(v);
}

/** Shape form state from backup JSON (or null → empty). */
export function normalizeContactFromBackup(raw) {
  if (raw === null) return { ...CONTACT_DEFAULT };
  if (!raw || typeof raw !== "object") return { ...CONTACT_DEFAULT };
  return {
    ...CONTACT_DEFAULT,
    mainText: str(raw.mainText),
    arMainText: str(raw.arMainText),
    sectionTitle: str(raw.sectionTitle),
    arSectionTitle: str(raw.arSectionTitle),
    subText: str(raw.subText),
    arSubText: str(raw.arSubText),
    description: str(raw.description),
    arDescription: str(raw.arDescription),
  };
}

export function normalizeJoinFromBackup(raw) {
  if (raw === null) return { ...JOIN_DEFAULT };
  if (!raw || typeof raw !== "object") return { ...JOIN_DEFAULT };
  return {
    ...JOIN_DEFAULT,
    mainText: str(raw.mainText),
    arMainText: str(raw.arMainText),
    sectionTitle: str(raw.sectionTitle),
    arSectionTitle: str(raw.arSectionTitle),
    description: str(raw.description),
    arDescription: str(raw.arDescription),
  };
}

/**
 * @param {unknown} data
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export function validateContactJoinCmsBackup(data) {
  if (data == null || typeof data !== "object" || Array.isArray(data)) {
    return { ok: false, message: "Backup must be a JSON object." };
  }
  if (
    data.format != null &&
    data.format !== CONTACT_JOIN_CMS_BUNDLE_FORMAT &&
    typeof data.format === "string"
  ) {
    return {
      ok: false,
      message: `Unknown backup format: ${data.format}. Expected "${CONTACT_JOIN_CMS_BUNDLE_FORMAT}" or omit format.`,
    };
  }
  if (data.version != null) {
    const v = Number(data.version);
    if (!Number.isFinite(v) || v !== 1) {
      return {
        ok: false,
        message: `Unsupported backup version: ${String(data.version)}.`,
      };
    }
  }
  const hasContact = "contact" in data;
  const hasJoin = "join" in data;
  if (!hasContact && !hasJoin) {
    return { ok: false, message: "Backup must include a contact and/or join object." };
  }
  if (hasContact && data.contact != null && typeof data.contact !== "object") {
    return { ok: false, message: "Field contact must be an object or null." };
  }
  if (hasJoin && data.join != null && typeof data.join !== "object") {
    return { ok: false, message: "Field join must be an object or null." };
  }
  return { ok: true };
}
